const columnData = [
  {
    header: "سال زراعی",
    accessorKey: "crop_year_name",
  },
  {
    header: "کشاورز ضامن",
    accessorKey: "guarantor_farmer_name",
    enableColumnFilter: false,
  },
  {
    header: "کشاورز ضمانت شده",
    accessorKey: "guaranteed_farmer_name",
    enableColumnFilter: false,
  },
  {
    header: () => (
      <div className="flex items-center gap-1">
        <span>
          {" "}
          مبلغ ضمانت <span className="text-blue-600">(تومان)</span>
        </span>
      </div>
    ),

    accessorKey: "guarantee_price",
    enableColumnFilter: false,
    cell: ({ getValue }: { getValue: () => any }) => {
      const value = getValue();
      return value ? value.toLocaleString("fa-IR") : "0";
    },
  },
];

export default columnData;
